<template>
  <div
    v-loading="loading"
    class="warnList"
    element-loading-text="正在保存数据"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <ComponentsList v-if="!dialogAddVisible&&!warnconfigVisible&&!dialogDetailVisible" ref="componentsList" :props-columns="columns" :props-data="propsData" :search-form="searchForm" @detailEmit="handleDetail">
      <module-title title="">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            @click="dialogAddVisible=true"
          >
            白名单管理
          </el-button>
          <el-button
            type="primary"
            size="medium"
            @click="SMSNotify"
          >
            预警短信通知
          </el-button>
          <el-button
            type="primary"
            size="medium"
            @click="handleWarnconfigVisible"
          >
            预警配置
          </el-button>
        </div>
      </module-title>
      <el-form
        ref="searchForm"
        :model="searchForm"
        :inline="true"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="账号状态：" prop="accountFrozen">
          <el-select
            v-model="searchForm.accountFrozen"
            style="width: 110px;"
          >
            <el-option label="全部" value="" />
            <el-option label="正常" :value="0" />
            <el-option label="已冻结" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="超管账号：" prop="accountPhone">
          <el-input
            v-model="searchForm.accountPhone"
            name="accountPhone"
            placeholder="请输入联系人号码"
            class="handle-form-input"
            maxlength="11"
            clearable
            @input="numberInputPhone"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearchFilter"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </ComponentsList>
    <el-dialog
      v-if="dialogSMSNotifyVisible"
      :close-on-click-modal="false"
      :visible.sync="dialogSMSNotifyVisible"
      title="预警短信通知"
      width="600px"
    >
      <el-form
        ref="SMSNotifyForm"
        :model="SMSNotifyForm"
        :rules="SMSNotifyrules"
        label-position="left"
        label-width="110px"
      >
        <el-form-item label="接收短信号码：" prop="phones">
          <el-input
            v-model="SMSNotifyForm.phones"
            name="name"
            type="textarea"
            rows="6"
            placeholder="请输入手机号码,并且逗号隔开"
            class="handle-form-input"
          />
          <span>可输入1-10个手机号码，多条手机号码以英文逗号隔开。</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogSMSNotifyVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleSMSNotify"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 预警配置 -->
    <div v-if="warnconfigVisible">
      <div class="right">
        <el-button
          type="primary"
          size="medium"
          @click="warnconfigVisible=false"
        >
          返回
        </el-button>
      </div>
      <div class="warnconfigmain">
        <el-form
          ref="handleFormWarnconfig"
          :model="handleFormWarnconfig"
          label-position="left"
          label-width="110px"
          :inline="true"
        >
          <div>
            <el-form-item label="每日阅读数量：" prop="name">
              <el-input-number
                v-model="handleFormWarnconfig.naturalDayConfig.bookNum"
                :min="0"
                :max="100000"
                name="batchAddSize"
                auto-complete="off"
                size="medium"
                placeholder="请输入"
                class="handle-form-input"
                oninput="value=value.replace(/[^\d]/g,'')"
                clearable
                @change="numberInput($event,99999,'handleFormWarnconfig.naturalDayConfig.bookNum')"
              />（本）
            </el-form-item>
          </div>
          <el-form-item label="时间窗：" prop="name">
            <el-input-number
              v-model="handleFormWarnconfig.timeIntervalConfig.timeInterval"
              :min="0"
              :max="720"
              name="batchAddSize"
              auto-complete="off"
              size="medium"
              placeholder="请输入"
              class="handle-form-input"
              clearable
              oninput="value=value.replace(/[^\d]/g,'')"
              @change="numberInput($event,719,'handleFormWarnconfig.timeIntervalConfig.timeInterval')"
            />（分）
          </el-form-item>
          <el-form-item label="阅读数量：" prop="bookNum">
            <el-input-number
              v-model="handleFormWarnconfig.timeIntervalConfig.bookNum"
              :min="0"
              :max="100000"
              name="batchAddSize"
              auto-complete="off"
              size="medium"
              placeholder="请输入"
              class="handle-form-input"
              oninput="value=value.replace(/[^\d]/g,'')"
              clearable
              @change="numberInput($event,99999,'handleFormWarnconfig.timeIntervalConfig.bookNum')"
            />（本）
          </el-form-item>
        </el-form>
        <div class="dialog-footer">
          <el-button
            :loading="ajaxLoading"
            type="primary"
            size="medium"
            @click="handleWarnconfig"
          >
            {{ ajaxLoading?'Loading':'保存' }}
          </el-button>
          <el-button size="medium" @click="warnconfigVisible=false">
            取消
          </el-button>
        </div>
      </div>
    </div>
    <ComponentsList v-if="dialogAddVisible" ref="componentsListAdd" :props-columns="columnsAdd" :props-data="propsDataAdd" :search-form="addForm">
      <module-title title="">
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            @click="addAccount"
          >
            添加账号
          </el-button>
          <el-button
            type="primary"
            size="medium"
            @click="dialogAddVisible=false"
          >
            返回
          </el-button>
        </div>
      </module-title>
    </ComponentsList>
    <el-dialog
      v-if="handleFormAdd.dialogAddVisible"
      :close-on-click-modal="false"
      :visible.sync="handleFormAdd.dialogAddVisible"
      title="添加账号"
      width="600px"
    >
      <el-form
        ref="handleFormAdd"
        :rules="handleFormAddRules"
        :model="handleFormAdd"
        label-position="left"
        label-width="170px"
      >
        <el-form-item label="超管账号（手机号）：" prop="mobile">
          <el-input
            v-model="handleFormAdd.mobile"
            name="mobile"
            maxlength="11"
            placeholder="请输入超管账号（手机号）"
            oninput="value=value.replace(/[^\d]/g,'')"
            class="handle-form-input"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="handleFormAdd.dialogAddVisible = false">
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleWarnAddAccount"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
    <ComponentsList v-if="dialogDetailVisible" ref="componentsDetail" :props-columns="columnsDetail" :props-data="propsDataDetail" :search-form="detailForm">
      <module-title title="">
        <h4>账号：{{ accountPhone }}</h4>
        <div class="right">
          <el-button
            type="primary"
            size="medium"
            @click="dialogDetailVisible=false"
          >
            返回
          </el-button>
        </div>
      </module-title>
    </ComponentsList>
  </div>
</template>

<script>
import EllaRentBooks from '@/api/userManagement/ellaRentBooks';
import ComponentsList from '@/views/financialCenter/ellaRentBooks/common/componentsList';
import { columnsWarnList, columnsWarnListAdd, columnsWarnListDetail } from '@/views/financialCenter/ellaRentBooks/common/columns';
export default {
  name: 'WarnList',
  components: { ComponentsList },
  data() {
    const validatePhone = (rule, value, callback) => {
      const pattern = new RegExp(/^1\d{10}$/);
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else {
        const str = value.split(',');
        if (str.some((item) => item.length !== 11 && item.length !== 0 && !pattern.test(item))) {
          callback(new Error('请输入正确的手机号'));
        }
        if (str.length > 10) {
          callback(new Error('最多只能10个手机号'));
        }
        callback();
      }
    };
    return {
      ajaxLoading: false,
      dialogAddVisible: false,
      dialogSMSNotifyVisible: false,
      warnconfigVisible: false,
      handleFormWarnconfig: {
        naturalDayConfig: {
          bookNum: 0,
          timeInterval: 0,
          id: ''
        },
        timeIntervalConfig: {
          bookNum: 0,
          timeInterval: 0,
          id: ''
        }
      },
      validate: false,
      loading: false,
      searchForm: {
        accountPhone: '',
        accountFrozen: '', // 1-冻结 2-正常
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      detailForm: {
        accountId: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      addForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      SMSNotifyForm: {
        phones: ''
      },
      accountPhone: '',
      dialogDetailVisible: false,
      propsData: {
        api: 'get_warnings_pageList'
      },
      propsDataDetail: {
        api: 'get_warnings_detail'
      },
      propsDataAdd: {
        api: 'get_whitelists_pageList'
      },
      handleFormAddRules: {
        mobile: [
          { required: true, message: '超管账号（手机号）不能为空', trigger: 'blur' },
          { max: 11, min: 11, message: '请输入11位数字', trigger: 'blur' }]
      },
      SMSNotifyrules: {
        phones: [{ validator: validatePhone, trigger: 'change', type: 'number' }]
      },
      handleFormAdd: { mobile: '', dialogAddVisible: false }
    };
  },
  computed: {
    columns() {
      return columnsWarnList;
    },
    columnsAdd() {
      return columnsWarnListAdd;
    },
    columnsDetail() {
      return columnsWarnListDetail;
    }
  },
  mounted() {
  },
  methods: {
    // 限制input只能输入数字
    numberInput(val, num, op) {
      const option = op.split('.');
      if (val) {
        this.validate = false;
        var regex = /^([+-]?[1-9]\d*|0)$/;
        if (!regex.test(val) || val > num) {
          this.validate = true;
          this.$message({
            message: `请输0-${num}的数字`,
            type: 'error',
            duration: 3 * 1000
          });
          this[option[0]][option[1]][option[2]] = num;
        }
      }
    },
    // 限制input只能输入数字
    numberInputPhone(val) {
      if (val) {
        this.searchForm.accountPhone = val.replace(/[^\d.]/g, '');
      }
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.$refs.componentsList.fetchdataList();
    },
    // 添加账号弹窗展示
    addAccount() {
      this.handleFormAdd.dialogAddVisible = true;
      this.handleFormAdd.mobile = '';
    },
    // 添加账号
    handleWarnAddAccount() {
      this.$refs.handleFormAdd.validate((valid) => {
        if (valid) {
          const op = {
            mobile: this.handleFormAdd.mobile
          };
          EllaRentBooks['get_whitelists_add'](op).then((res) => {
            if (res.code === '0') {
              this.handleFormAdd.dialogAddVisible = false;
              this.$message.success('添加成功');
              this.$refs.componentsListAdd.fetchdataList();
            }
          }).catch(err => {
            console.log(err);
          });
        }
      });
    },
    // 预警短信通知弹窗
    SMSNotify() {
      this.dialogSMSNotifyVisible = true;
      const op = {
        type: 2
      };
      EllaRentBooks['get_resourceWarning'](op).then((res) => {
        if (res.code === '0') {
          this.SMSNotifyForm.phones = res.data;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 预警短信通知
    handleSMSNotify() {
      this.$refs.SMSNotifyForm.validate((valid) => {
        if (valid) {
          const str = this.SMSNotifyForm.phones.split(',');
          var r = str.filter((item) => {
            return item.length > 0;
          });
          const phone = [...new Set(r)];
          const phones = [...new Set(r)].join(',');
          if (r.length !== phone.length) {
            this.$message.warning('已去除重复的手机号');
          }
          EllaRentBooks['get_resourceWarning_add']({
            phones, type: 2
          }).then((res) => {
            if (res.code === '0') {
              this.dialogSMSNotifyVisible = false;
              this.$message.success('数据保存成功');
            }
          });
        }
      });
    },
    // 预警配置页面展示
    handleWarnconfigVisible() {
      this.warnconfigVisible = true;
      EllaRentBooks['get_warnconfigs_pageList']().then((res) => {
        if (res.code === '0') {
          this.handleFormWarnconfig.naturalDayConfig = Object.assign({}, this.handleFormWarnconfig.naturalDayConfig, res.data.naturalDayConfig);
          this.handleFormWarnconfig.timeIntervalConfig = Object.assign({}, this.handleFormWarnconfig.timeIntervalConfig, res.data.timeIntervalConfig);
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 预警配置
    handleWarnconfig() {
      if (this.validate) return;
      this.loading = true;
      const op = {
        naturalDayConfig: {
          bookNum: this.handleFormWarnconfig.naturalDayConfig.bookNum,
          id: this.handleFormWarnconfig.naturalDayConfig.id
        },
        timeIntervalConfig: {
          bookNum: this.handleFormWarnconfig.timeIntervalConfig.bookNum,
          timeInterval: this.handleFormWarnconfig.timeIntervalConfig.timeInterval,
          id: this.handleFormWarnconfig.timeIntervalConfig.id
        }
      };
      EllaRentBooks['get_warnconfigs'](op).then((res) => {
        if (res.code === '0') {
          this.$message.success('操作成功');
          this.handleWarnconfigVisible();
          this.loading = false;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    // 详情展示
    handleDetail(val) {
      this.accountPhone = val.accountPhone;
      this.detailForm.accountId = val.accountId;
      this.dialogDetailVisible = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.warnconfigmain{
  padding-top: 50px;
  padding-left: 80px;
  clear: both;
  .dialog-footer{
    margin-top: 30px;
    text-align: center;
    button{
      margin-right: 20px;
    }
  }
}
</style>
